export default __webpack_public_path__ + "static/media/info_image_02.173205a9.png";